<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="list"
      :loading="loading"
      sort-by="calories"
      :loading-text="$table_loading_text"
      :page.sync="page"
      :items-per-page="filter.item_per_page"
      hide-default-footer
      show-select
      item-key="_id"
      v-model="selected"
      :key="selected.length"
      @input="$emit('on-selected', selected)"
    >
      <template v-slot:[`item._id`]="{ item }">
        {{
          list
            .map(function (x) {
              return x._id;
            })
            .indexOf(item._id) +
          1 +
          filter.item_per_page * (filter.page - 1)
        }}
      </template>
      <template v-slot:[`item.date`]="{ item }">
        {{ formatDate(item.date) }}
      </template>
      <template v-slot:footer>
        <cursor-pager
          :page="filter.page"
          :items-per-page="filter.item_per_page"
          :can-previous="cursorHistory.length > 1"
          :can-next="hasMore"
          :loading="loading"
          @previous="goPreviousPage"
          @next="goNextPage"
          @change-items-per-page="changePageSize"
        />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import listFilterMixin from './listFilterMixin';
import * as moment from 'moment';
export default {
  mixins: [listFilterMixin],
  props: ['updateList'],
  data: () => ({
    selected: [],
    loading: true,
    page: 1,
    list: [],
    headers: [
      { text: 'ลำดับ', value: '_id', filterable: false },
      { text: 'วันที่สร้างบิล', value: 'date', filterable: false },
      { text: 'ทะเบียน', value: 'car_plate', filterable: false },
      { text: 'จัวหวัด', value: 'province', filterable: false },
      { text: 'โน๊ต', value: 'note', filterable: false },
      { text: 'หมายเหตุ', value: 'reason_on_fail', filterable: false },
    ],

    isCar: true,
    filter: {
      branch_id: null,
      tracking_type: 0,
      tracking_status: 4,
      tax_renewal_round: '',
      car_type_filter: 0,
      item_per_page: 20,
      page: 1,
      start_with: '',
    },
  }),
  mounted() {
    this.filter.branch_id = this.$store.state.selected_branch._id;
    this.getData();
  },
  methods: {
    async getData() {
      this.loading = true;
      let body = {
        token: this.$jwt.sign(this.filter, this.$privateKey, {
          noTimestamp: true,
        }),
      };
      await this.$axios
        .post(`${this.$baseUrl}/process/get_process`, body)
        .then((res) => {
          this.list = res.result.data;
          this.applyPageResult(res.result);
        
        })
        .catch((err) => {
          console.log('err', err);
          this.$alertServerError({ title: err.error_message });
        });
      this.loading = false;
    },
    formatDate(date) {
      if (!date) return '';

      let year = parseInt(moment(date).format('YYYY'));
      let m_d = moment(date).format('DD/MM');
      return `${m_d}/${year + 543}`;
    },
  },
  watch: {
    updateList(nv, ov) {
      this.getData();
    },
  },
};
</script>
